import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import SeriesImgs from './seriesImgs';
import HotImgs from './hotImgs';
import SeriesRank from './seriesRank';
import SeriesPrice from './seriesPrice';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            asideAd1,
            asideAd2,
            asideAd3,
            asideAd4,
            tuanRecommendr1,
            tuanRecommendr2,
            hotImgs,
            carSeriesData,
            seriesInfo,
            curCity,
        } = content;

        return (
            <div className={styles.rightContent}>
                <Ad content={asideAd1} styleName={styles.asideAd1} />
                <div className={styles.space15} />
                {tuanRecommendr1 ? (
                    <a href={tuanRecommendr1[0].url} target="_blank" rel={rel}>
                        <img src={tuanRecommendr1[0].img} />
                    </a>
                ) : (
                    ''
                )}
                <div className={styles.space15} />
                {carSeriesData ? <SeriesImgs content={carSeriesData} seriesInfo={seriesInfo} /> : ''}
                <div className={styles.space15} />
                {hotImgs ? <HotImgs content={hotImgs} /> : ''}
                <div className={styles.space15} />
                <Ad content={asideAd2} styleName={styles.asideAd2} />
                <div className={styles.space15} />
                <SeriesRank content={carSeriesData} />
                <Ad content={asideAd3} styleName={styles.asideAd3} />
                <div className={styles.space15} />
                {tuanRecommendr2 ? (
                    <div>
                        <a href={tuanRecommendr2[0].url} target="_blank">
                            <img src={tuanRecommendr2[0].img} />
                        </a>
                    </div>
                ) : (
                    ''
                )}

                <div className={styles.space15} />
                <Ad content={asideAd4} styleName={styles.asideAd4} />
                {carSeriesData && curCity ? (
                    <SeriesPrice content={carSeriesData} seriesInfo={seriesInfo} curCity={curCity} />
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(RightContent);
